import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaHome, FaGraduationCap, FaUser, FaImages, FaNewspaper, FaFileAlt, FaCog, FaShieldAlt, FaCode, FaLaptop, FaNetworkWired, FaComments } from "react-icons/fa";

// Routes synced exactly with App.js — no dead links
const routes = [
  // Main
  { path: "/",                    name: "Home",                    keywords: ["home", "main", "landing", "welcome"],                                           category: "Main",          icon: FaHome },
  // About
  { path: "/about",               name: "About Us",                keywords: ["about", "history", "who we are", "institution"],                                category: "About",         icon: FaUser },
  { path: "/about/mission",       name: "Mission & Vision",        keywords: ["mission", "vision", "goals", "values", "objectives"],                           category: "About",         icon: FaUser },
  { path: "/about/trustees",      name: "Advisory Board",          keywords: ["trustees", "board", "advisory", "leadership", "directors"],                     category: "About",         icon: FaUser },
  { path: "/about/terms-conditions", name: "Terms & Conditions",   keywords: ["terms", "conditions", "policy", "legal", "agreement"],                         category: "About",         icon: FaFileAlt },
  // Courses
  { path: "/course/information-technology",    name: "Information Technology",        keywords: ["information technology", "it", "computer", "programming", "systems"],          category: "Courses", icon: FaLaptop },
  { path: "/course/cyber-security",            name: "Cyber Security",                keywords: ["cyber", "security", "hacking", "cybersecurity", "ethical hacking"],           category: "Courses", icon: FaShieldAlt },
  { path: "/course/business-administration",   name: "Business Administration",       keywords: ["business", "administration", "management", "commerce", "corporate"],          category: "Courses", icon: FaGraduationCap },
  { path: "/course/travel-tourism-management", name: "Travel & Tourism Management",   keywords: ["travel", "tourism", "hospitality", "travel management"],                      category: "Courses", icon: FaGraduationCap },
  { path: "/course/short-courses",             name: "Short Courses",                 keywords: ["short courses", "certificates", "training", "skills"],                        category: "Courses", icon: FaGraduationCap },
  { path: "/course/professional-courses",      name: "Professional Courses",          keywords: ["professional courses", "certification", "career", "development"],             category: "Courses", icon: FaGraduationCap },
  // Professional Course Detail Pages
  { path: "/courses/professional-courses/comptia",                   name: "CompTIA Certifications",          keywords: ["comptia", "a+", "network+", "security+", "it certification", "vendor neutral"], category: "Professional", icon: FaShieldAlt },
  { path: "/courses/professional-courses/cisco-networking-academy",  name: "Cisco Networking Academy",        keywords: ["cisco", "ccna", "ccnp", "networking", "ccie", "routing", "switching"],          category: "Professional", icon: FaNetworkWired },
  { path: "/courses/professional-courses/ec-council",                name: "EC-Council Certifications",       keywords: ["ec-council", "ceh", "cct", "cscu", "ethical hacking", "certified"],             category: "Professional", icon: FaShieldAlt },
  // Gallery
  { path: "/gallery/photos", name: "Photo Gallery", keywords: ["photos", "gallery", "images", "pictures", "photography"],  category: "Gallery", icon: FaImages },
  { path: "/gallery/videos", name: "Video Gallery", keywords: ["videos", "gallery", "media", "multimedia", "video"],       category: "Gallery", icon: FaImages },
  // News & Events
  { path: "/events", name: "All Events", keywords: ["events", "calendar", "schedule", "activities", "functions"], category: "Events", icon: FaNewspaper },
  { path: "/news",   name: "All News",   keywords: ["news", "updates", "announcements", "latest", "current"],     category: "News",   icon: FaNewspaper },
  // Admissions
  { path: "/admissions", name: "Admissions",  keywords: ["admissions", "enrollment", "requirements", "process"],             category: "Admissions", icon: FaFileAlt },
  { path: "/apply",      name: "Apply Now",   keywords: ["apply", "application", "admission", "enroll", "register", "join"], category: "Admissions", icon: FaFileAlt },
  { path: "/fees",       name: "Fee Structure", keywords: ["fees", "cost", "tuition", "payment", "pricing", "financial"],    category: "Admissions", icon: FaFileAlt },
  // Academic
  // HIDDEN 2026-08-04 at client request — unhide by restoring these two entries.
  // { path: "/academics",   name: "Academics",   keywords: ["academics", "education", "learning", "curriculum", "degrees", "certificates"], category: "Academic", icon: FaGraduationCap },
  // { path: "/departments", name: "Departments", keywords: ["departments", "faculty", "schools", "divisions"],                              category: "Academic", icon: FaGraduationCap },
  // HIDDEN 2026-08-04 at client request — unhide by restoring this entry.
  // { path: "/library",     name: "Library",     keywords: ["library", "books", "resources", "research", "study", "materials"],            category: "Academic", icon: FaFileAlt },
  // Campus Life
  { path: "/athletics",       name: "Athletics",       keywords: ["athletics", "sports", "fitness", "games", "physical"],       category: "Campus Life", icon: FaUser },
  { path: "/athletics/news",  name: "Athletics News",  keywords: ["athletics news", "sports news", "games update"],             category: "Campus Life", icon: FaNewspaper },
  { path: "/campus-tour",     name: "Campus Tour",     keywords: ["campus tour", "tour", "visit", "facilities", "virtual"],    category: "Campus Life", icon: FaUser },
  // Services & Support
  { path: "/services",                        name: "Services",               keywords: ["services", "support", "assistance", "career services"],                       category: "Support", icon: FaCog },
  { path: "/services/jr-media-productions",  name: "JR Media Productions",   keywords: ["media", "productions", "jr media", "video production", "photography"],       category: "Support", icon: FaCode },
  { path: "/services/data-analysis",         name: "Data Analysis Services", keywords: ["data analysis", "analytics", "statistics", "research", "data science"],      category: "Support", icon: FaCog },
  { path: "/feedback",                       name: "Feedback",               keywords: ["feedback", "suggestions", "complaints", "reviews", "report"],                 category: "Support", icon: FaComments },
  { path: "/contact",                        name: "Contact Us",             keywords: ["contact", "reach", "get in touch", "communication", "help"],                  category: "Support", icon: FaUser },
  // Student
  { path: "/student-portal", name: "Student Portal", keywords: ["student portal", "portal", "login", "dashboard", "student access"], category: "Student", icon: FaUser },
];

const SmartSearch = ({ isOpen, onClose, searchTerm, setSearchTerm, className }) => {
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const resultsRef = useRef(null);

  // Search algorithm with scoring
  const searchRoutes = (query) => {
    if (!query.trim()) {
      setFilteredRoutes([]);
      return;
    }

    const queryLower = query.toLowerCase();
    const results = routes
      .map(route => {
        let score = 0;
        const nameLower = route.name.toLowerCase();
        const pathLower = route.path.toLowerCase();
        const keywordsLower = route.keywords.map(k => k.toLowerCase());

        // Exact name match (highest priority)
        if (nameLower === queryLower) {
          score += 100;
        }
        // Name starts with query
        else if (nameLower.startsWith(queryLower)) {
          score += 80;
        }
        // Name contains query
        else if (nameLower.includes(queryLower)) {
          score += 60;
        }

        // Path contains query
        if (pathLower.includes(queryLower)) {
          score += 40;
        }

        // Keyword matches
        const keywordMatches = keywordsLower.filter(keyword => 
          keyword.includes(queryLower) || queryLower.includes(keyword)
        );
        score += keywordMatches.length * 20;

        // Partial keyword matches
        const partialMatches = keywordsLower.filter(keyword => 
          keyword.split(' ').some(word => word.startsWith(queryLower)) ||
          queryLower.split(' ').some(word => keyword.includes(word))
        );
        score += partialMatches.length * 10;

        return { ...route, score };
      })
      .filter(route => route.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 8);

    setFilteredRoutes(results);
  };

  // Handle search input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchRoutes(searchTerm);
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!isOpen) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < filteredRoutes.length - 1 ? prev + 1 : 0
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev > 0 ? prev - 1 : filteredRoutes.length - 1
        );
        break;
      case 'Enter':
        e.preventDefault();
        if (filteredRoutes[selectedIndex]) {
          handleRouteClick(filteredRoutes[selectedIndex]);
        }
        break;
      case 'Escape':
        onClose();
        break;
      default:
        break;
    }
  };

  // Handle route click
  const handleRouteClick = (route) => {
    navigate(route.path);
    setSearchTerm('');
    onClose();
  };

  // Highlight matching text
  const highlightText = (text, query) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <mark key={index} className="bg-yellow-200 text-yellow-900 px-1 rounded">
          {part}
        </mark>
      ) : part
    );
  };

  // Get category color
  const getCategoryColor = (category) => {
    const colors = {
      'Main': 'bg-blue-100 text-blue-800',
      'About': 'bg-purple-100 text-purple-800',
      'Courses': 'bg-green-100 text-green-800',
      'IT Programs': 'bg-indigo-100 text-indigo-800',
      'Cyber Security': 'bg-red-100 text-red-800',
      'Computer Science': 'bg-orange-100 text-orange-800',
      'Computer Engineering': 'bg-teal-100 text-teal-800',
      'Gallery': 'bg-pink-100 text-pink-800',
      'Events': 'bg-yellow-100 text-yellow-800',
      'News': 'bg-gray-100 text-gray-800',
      'Admissions': 'bg-custom-pink text-white',
      'Student': 'bg-blue-100 text-blue-800',
      'Support': 'bg-gray-100 text-gray-800',
      'Financial': 'bg-green-100 text-green-800',
      'Campus Life': 'bg-purple-100 text-purple-800',
      'Academic': 'bg-indigo-100 text-indigo-800',
      'Resources': 'bg-orange-100 text-orange-800'
    };
    return colors[category] || 'bg-gray-100 text-gray-800';
  };

  if (!isOpen) return null;

  return (
    <div className={className ?? "absolute right-0 top-full mt-2 w-96 bg-white rounded-lg shadow-xl z-50 border border-gray-200"}>
      <div className="p-4">
        <div className="relative">
          <input
            ref={searchRef}
            type="text"
            placeholder="Search courses, pages, and more..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-pink focus:border-transparent text-sm"
            autoFocus
          />
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>

        <div ref={resultsRef} className="mt-4 max-h-96 overflow-y-auto">
          {filteredRoutes.length > 0 ? (
            <div className="space-y-1">
              {filteredRoutes.map((route, index) => {
                const IconComponent = route.icon;
                return (
                  <div
                    key={route.path}
                    onClick={() => handleRouteClick(route)}
                    className={`flex items-center p-3 rounded-lg cursor-pointer transition-colors ${
                      index === selectedIndex
                        ? 'bg-custom-pink text-white'
                        : 'hover:bg-gray-100'
                    }`}
                  >
                    <div className={`flex-shrink-0 mr-3 ${
                      index === selectedIndex ? 'text-white' : 'text-custom-pink'
                    }`}>
                      <IconComponent className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <p className={`text-sm font-medium truncate ${
                          index === selectedIndex ? 'text-white' : 'text-gray-900'
                        }`}>
                          {highlightText(route.name, searchTerm)}
                        </p>
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          index === selectedIndex 
                            ? 'bg-white bg-opacity-20 text-white' 
                            : getCategoryColor(route.category)
                        }`}>
                          {route.category}
                        </span>
                      </div>
                      <p className={`text-xs mt-1 truncate ${
                        index === selectedIndex ? 'text-white text-opacity-80' : 'text-gray-500'
                      }`}>
                        {route.path}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : searchTerm.trim() ? (
            <div className="text-center py-8">
              <FaSearch className="mx-auto text-gray-400 text-2xl mb-2" />
              <p className="text-gray-500 text-sm">No results found for "{searchTerm}"</p>
              <p className="text-gray-400 text-xs mt-1">Try different keywords or check spelling</p>
            </div>
          ) : (
            <div className="text-center py-8">
              <FaSearch className="mx-auto text-custom-pink text-2xl mb-2" />
              <p className="text-gray-500 text-sm">Start typing to search</p>
              <p className="text-gray-400 text-xs mt-1">Find courses, pages, and more</p>
            </div>
          )}
        </div>

        <div className="mt-4 pt-3 border-t border-gray-200">
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>Press ↑↓ to navigate</span>
            <span>Press Enter to select</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartSearch;